<template>
    <div class="wrapper">
      <div class="header-wrapper">
        <div class="header">市教育局金点子</div>
        <div class="addManager">
          <Button class="bkcc-btn" @click="download">导出</Button>
        </div>
      </div>
      <div class="content">
        <Card>
          <div class="select-wrapper">
            <div>
              <div class="name">问题内容</div>
              <Input v-model="content" placeholder="请输入问题内容" clearable style="width: 400px" />
            </div>
            
            <div>
              <div class="name">金点子类型</div>
              <Select v-model="type" filterable  style="width: 400px">
                  <Option v-for="item in typeList" :value="item.name" :key="item.name">{{ item.name }}</Option>
              </Select>
            </div>
            
            <Button style="position: absolute;right: 20px" @click="getVoteList">搜索</Button>
          </div>
        </Card>
        <Card class="card" style="margin-top: 20px">
          <Table border :columns="columns1" :data="votedata" :loading="isTableLoading"></Table>
          <div class="page">
            <Page :total="total" :current="pageNum" @on-change="handleChangePage" show-total />
          </div>
        </Card>
      </div>
    
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        columns1: [
          {
            title: "序号",
            type: 'index',
            width: 80,
            align: 'center'
          },
          {
            title: "单号",
            key: "id",
            width: 190,
            align: 'center'
          },
          {
            title: "问题类型",
            key: "type",
            width: 150,
            align: 'center'
          },
          {
            title: "提交时间",
            key: "createTime",
            align: 'center',
            width: 180
          },
          {
            title: "姓名/电话",
            width: 140,
            align: 'center',
            render: (h, params) => {
              return h("div", [
                h("span", params.row.userName||'匿名'),
                h("br"),
                h("span", params.row.phone)
              ]);
            }
          },
          {
            title: "上传图片",
            key: "content",
            align: 'center',
            width: 280,
            render: (h, params) => {
              let imgList = params.row.picUrl ? params.row.picUrl.split(',') : [];
              let imgArr = [];
              for (let i = 0; i < imgList.length; i++) {
                imgArr.push(h("viewer",{},[
                  h("img", {
                    style: {
                      "width": "60px",
                      "height": "60px",
                      "object-fit":"cover",
                      "margin-right": "10px"
                    },
                    attrs: {
                      src: imgList[i],
                      alt: "图片加载失败"
                    }
                  })
                ]));
              }
              return h("div",
                {
                  style: {
                    "display": "flex",
                    "align-items": "center"
                  }
                },imgArr);
              }
          },
          {
            title: "反馈内容",
            key: "content",
            render: (h, params) => {
              return h("Tooltip",{
                props: {
                    content:params.row.content,
                    placement: "top",
                    maxWidth:"800"
                },
              },[
                h("div", {
                    style: {
                        wordbreak: "break-all",
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitLineClamp: "2",
                        WebkitBoxOrient: "vertical",
                        width: "100%",
                      }
                },params.row.content)
            ]);
            }
          },
         
        ],
        votedata: [],
        typeList: [],
        content: "",
        pageNum: 1,
        pageSize: 10,
        total: 20,
        isTableLoading: false,
        type:""
      };
    },
    computed :{
    },
    created() {
    },
    mounted() {
      this.getType()
      this.getVoteList();
    },
    methods: {
      download(){
        window.open(
          `${this.urlobj.ideaExport}?content=${this.content}&type=${this.type}&token=${this.$store.state.access_token}`
        );
      },
      getType() {
        try{
          var url = this.urlobj.GetCodeByTypeforPhone;
          this.$get(url, {
            typeName:"jdzwtfl"
          }).then(res => {
            this.typeList = res.rows;
          });
        } catch (e) {
          console.log(e);
        }
      },
      getVoteList() {
        var url = this.urlobj.listJczlbureaueducationidea;
        this.isTableLoading = true;
        var data = {
          content: this.content,
          type: this.type,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        };
        this.$get(url, data).then(res => {
          this.votedata = res.rows
          this.total = res.total;
          this.isTableLoading = false;
        });
      },
      handleChangePage(val) {
        this.pageNum = val;
        this.getVoteList();
      },
    }
  };
  </script>
  
  <style lang='less' scoped>
  .wrapper {
    color: #666666;
    overflow: hidden;
    height: 100%;
  }
  
  .wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    /* height: 4px; */
  }
  .header-wrapper {
    display: flex;
    justify-content: center;
    height: 84px;
    line-height: 84px;
    position: relative;
  }
  .header {
    font-size: 25px;
    text-align: center;
  }
  .addManager {
    position: absolute;
    right: 20px;
  }
  .content {
    //   @content();
    // max-width: 96%;
    margin: 20px;
    margin-top: 0;
    overflow: hidden;
    overflow-y: scroll;
    // background: #fff;
    // padding: 0 15px 0 15px;
    &::-webkit-scrollbar {
      display: none;
    }
    .select-wrapper {
      display: flex;
      font-size: 16px;
      margin-bottom: 20px;
      >div{
        margin-right: 10px;
      }
    }
    .card {
      height: 100%;
    }
    /deep/ .ivu-table-overflowX {
      overflow-x: hidden !important;
    }
    /deep/ .ivu-table-wrapper {
      overflow:visible !important;
    }
  }
  .search {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
  }
  .table-tabs {
    max-width: 100%;
    padding: 0;
    margin-top: 30px;
  
    /deep/ .ivu-tabs-bar {
      margin-bottom: 0;
      border-bottom: 0;
    }
    /deep/ .ivu-tabs-tab-active {
      color: white;
      background: #fe7d43;
      border-radius: 5px 5px 0 0;
    }
    /deep/ .ivu-tabs-ink-bar {
      height: 0px;
    }
    /deep/ .ivu-tabs-nav {
      padding-left: 10px;
      color: black;
    }
  }
  
  .table-data {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    min-height: calc(100vh - 450px);
  }
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
  }
  .code-img {
    margin: 20px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    // width: 172px;
    height: 172px;
    img {
      width: 172px;
      height: 172px;
    }
  }
  .text {
    font-size: 16px;
    span {
      text-decoration: underline;
      color: #fe7d43;
    }
  }
  /deep/ .ivu-table-tip table td{
    width: 100% !important;
  }
  /deep/ th .ivu-table-cell span {
    font-weight: bold !important;
  }
  </style>
  